import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {imageMap} from "../../../../images/imageMap.ts";
import {Link} from "react-router-dom";
import Routing from "../../../../Routing.ts";

export default function MistetKortArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article article--connect">
                    <div className="paragraph">
                        <p>
                            Det er vigtigt at du kontakter os hurtigst muligt &ndash; så finder vi en løsning, så du undgår rykkere.
                            Vi kan godt udskyde din regning, indtil du har modtaget dit nye kort.
                        </p>
                        <p>
                            Når du modtager dit nye kort, skal du selv tilføje det i Mit Hiper under <Link to={Routing.Selfcare.Card}>Betaling</Link> og derefter betale regningen.
                            Alle regninger bliver fremover trukket fra det nye kort.
                        </p>
                    </div>
                </div>
                <div className="article">
                    <div className="paragraph">
                        <h2>Har du flere abonnementer?</h2>
                        <p>
                            Når du får et nyt kort, skal du huske at tilføje det på alle dine abonnementer i Mit Hiper.
                            Du kan skifte mellem dine abonnementer ved at trykke oppe i venstre hjørne, hvor din adresse og kundenummer står.
                        </p>
                    </div>
                    <img
                        className="paragraph-image box-shadow"
                        src={imageMap.help.subscription.selfcare_multiple_profiles}
                        alt="Grafik der illustrerer hvor man kan skifte profil."
                    />
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "regning-og-betaling",
                        "article": "betalingsmuligheder",
                        "name": "Betalingsmuligheder"
                    },
                    {
                        "category": "mit-abonnement",
                        "article": "mit-hiper",
                        "name": "Mit Hiper"
                    }
                ]}
            />
        </>
    )
}
